'use strict';

define('lib/analytics/pageload',[
  'jquery',
  './context.get',
  'lib/analytics/trigger',
  './combineBlocks'
], function (
  $,
  contextGet,
  trigger,
  combineBlocks
) {
  return function anPageLoad(scope) {
    var $scope = $(scope);
    var localBlocks = Array.prototype.slice.call(arguments); // turn args into legit Arr
    localBlocks.shift(); // remove scope

    trigger('ready', [
      contextGet($scope),
      combineBlocks(localBlocks) // any blocks that come WITH a pageLoad must win over its context
    ]);
  };
});

